import { LanguageSelectorTheme } from "@acin.reactjs/acin-ui/language-selector";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { AppMediaQueries } from "./BreakpointsTheme";

const languageSelectorTheme: ComponentCSSStyle<LanguageSelectorTheme> = {
  variants: {
    navigationBar: {
      button: {
        marginLeft: "20px",
      },

      dropdown: {
        root: {
          marginTop: "20px",
        },
      },
      menuList: {
        item: {
          label: {
            [AppMediaQueries.maxMobile]: {
              fontSize: "14px",
            },
          },
        },
      },
    },
    footer: {
      button: {
        backgroundColor: "transparent",
      },
    },
  },
};

export default languageSelectorTheme;
